import { render } from "./Celebrations.vue?vue&type=template&id=7afa8606&scoped=true&ts=true"
import script from "./Celebrations.vue?vue&type=script&lang=ts"
export * from "./Celebrations.vue?vue&type=script&lang=ts"

import "./Celebrations.vue?vue&type=style&index=0&id=7afa8606&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afa8606"]])

export default __exports__